__turbopack_context__.v({
  "entity": "broadcastEntity-module-scss-module__MOsz-W__entity",
  "image": "broadcastEntity-module-scss-module__MOsz-W__image",
  "title": "broadcastEntity-module-scss-module__MOsz-W__title",
});
